(function () {
  function init(root) {
    if (!root || root.dataset.rawffReady) return;
    root.dataset.rawffReady = 'true';

    var menu = root.querySelector('[data-rawff-menu]');
    var nav = root.querySelector('[data-rawff-nav]');
    if (menu && nav) {
      menu.addEventListener('click', function () {
        nav.classList.toggle('is-open');
        menu.setAttribute('aria-expanded', nav.classList.contains('is-open'));
      });
      nav.addEventListener('click', function (event) {
        if (event.target.closest('a')) nav.classList.remove('is-open');
      });
    }

    var weight = root.querySelector('[data-rawff-weight]');
    var stage = root.querySelector('[data-rawff-stage]');
    var grams = root.querySelector('[data-rawff-grams]');
    var packs = root.querySelector('[data-rawff-packs]');
    var note = root.querySelector('[data-rawff-note]');
    var notes = {
      adult: "Feed to body condition, not to the number. You should be able to feel your dog's ribs easily without pressing, and see a waist from above. If they are gaining or losing, move the amount by 10% and hold it for two weeks before adjusting again.",
      puppy: 'Puppies need proportionally far more food than adults, and the right figure drops steadily as they grow. Please work out the specific amount with your vet, and reweigh every couple of weeks.',
      senior: 'Older dogs often need less energy but the same protein. Watch condition closely, and raise it with your vet if you notice muscle loss rather than fat loss.'
    };
    function round5(value) { return Math.round(value / 5) * 5; }
    function calculate() {
      if (!weight || !stage) return;
      var kg = parseFloat(weight.value);
      if (!kg || kg <= 0) {
        grams.textContent = '—';
        packs.textContent = 'Enter a weight above.';
        return;
      }
      var values = stage.value.split(',');
      var low = round5(kg * 10 * parseFloat(values[0]));
      var high = round5(kg * 10 * parseFloat(values[1]));
      var dailyLow = low / 450;
      var dailyHigh = high / 450;
      grams.textContent = low + '–' + high + ' g';
      packs.textContent = 'Roughly ' + dailyLow.toFixed(1) + '–' + dailyHigh.toFixed(1) + ' packs a day · about ' + (dailyLow * 7).toFixed(1) + '–' + (dailyHigh * 7).toFixed(1) + ' packs a week';
      note.textContent = notes[values[2] || 'adult'];
    }
    if (weight && stage) {
      weight.addEventListener('input', calculate);
      stage.addEventListener('change', calculate);
      calculate();
    }
  }

  document.querySelectorAll('[data-rawff-root]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-rawff-root]'));
  });
})();
